import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { BitSvg, isBitSvg } from "@vowkey/assets/svg";

@Component({
  selector: "bit-svg",
  host: {
    "[attr.aria-hidden]": "!ariaLabel()",
    "[attr.aria-label]": "ariaLabel()",
    "[innerHtml]": "innerHtml()",
    class: "tw-max-h-full tw-flex tw-justify-center",
    "[attr.role]": "ariaLabel() ? 'img' : 'presentation'",
  },
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgComponent {
  private readonly domSanitizer = inject(DomSanitizer);

  readonly content = input<BitSvg>();
  readonly ariaLabel = input<string>();

  protected readonly innerHtml = computed<SafeHtml | null>(() => {
    const content = this.content();
    if (!isBitSvg(content)) {
      return null;
    }
    const svg = content.svg;
    return this.domSanitizer.bypassSecurityTrustHtml(svg);
  });
}
